import { useState, useCallback, useRef, useEffect } from 'react';
import { RANKINGS } from '../data/rankings';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
export default function HigherOrLower({onBack,best,setBest}){
  const [phase,setPhase]=useState('home');
  const [deck,setDeck]=useState([]);
  const [idx,setIdx]=useState(0);
  const [left,setLeft]=useState(null);
  const [right,setRight]=useState(null);
  const [score,setScore]=useState(0);
  const [streak,setStreak]=useState(0);
  const [flash,setFlash]=useState('');
  const [result,setResult]=useState(null);
  const [history,setHistory]=useState([]);
  const t=useRef(null);
  const start=useCallback(()=>{
    const d=shuffle(RANKINGS);
    setDeck(d);setLeft(d[0]);setRight(d[1]);setIdx(2);
    setScore(0);setStreak(0);setHistory([d[0]]);setFlash('');setResult(null);setPhase('play');
  },[]);
  const guess=useCallback((higher)=>{
    if(result)return;
    const ok=higher===(right.rank<left.rank);
    const ns=ok?score+1:score,nst=ok?streak+1:0;
    setScore(ns);setStreak(nst);if(ns>best)setBest(ns);
    setFlash(ok?'fc':'fw');
    setResult({ok,msg:ok?'Correct! '+right.name+' is #'+right.rank:'Wrong! '+right.name+' is #'+right.rank});
    clearTimeout(t.current);
    t.current=setTimeout(()=>{
      setFlash('');setResult(null);
      if(!ok||idx>=deck.length){setPhase('over');return;}
      const nl=right,nr=deck[idx];
      setHistory(h=>[...h,nl]);setLeft(nl);setRight(nr);setIdx(i=>i+1);
    },1400);
  },[result,right,left,score,streak,best,idx,deck,setBest]);
  useEffect(()=>()=>clearTimeout(t.current),[]);
  const rating=score>=20?'World Class':score>=12?'International':score>=6?'Amateur':'Sunday League';
  return(<div className="hl-wrap layer">
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title">HIGHER OR LOWER</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill y"><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className="g-pill y"><span className="g-plbl">Streak</span><span className="g-pval">{streak}{streak>=3?'🔥':''}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#f5c518',border:'1px solid #c9a012'}}>FIFA Rankings</div>
      <h1 className="game-big" style={{color:'#f5c518'}}>HIGHER<br/>OR LOWER</h1>
      <p className="game-desc">Two nations. Is the second ranked <strong>higher</strong> or <strong>lower</strong>?</p>
      {best>0&&<p className="game-best" style={{color:'#f5c518'}}>Best: {best}</p>}
      <button className="btn-gold" style={{marginTop:8}} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#ef4444',border:'1px solid #ef4444'}}>GAME OVER</div>
      <h1 className="over-h1">{rating}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#f5c518'}}>{score}</span><span className="over-lbl">Score</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#f5c518'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button className="btn-gold" onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&left&&right&&<>
      <div className="hl-arena">
        <div className={'hl-card lft '+flash}>
          <div className="hl-flag">{left.flag}</div>
          <div className="hl-name">{left.name}</div>
          <div className="hl-bdg s"><span className="hl-rn">#{left.rank}</span><span className="hl-rl">FIFA Rank</span></div>
        </div>
        <div className="hl-vs-col">
          <div className="hl-vs">VS</div>
          <div className="hl-btns">
            <button className="hl-btn up" onClick={()=>guess(true)} disabled={!!result}><span className="hl-ba">▲</span><span className="hl-bt">HIGHER</span><span className="hl-bs">Better rank</span></button>
            <button className="hl-btn dn" onClick={()=>guess(false)} disabled={!!result}><span className="hl-ba">▼</span><span className="hl-bt">LOWER</span><span className="hl-bs">Worse rank</span></button>
          </div>
        </div>
        <div className={'hl-card rgt '+flash}>
          <div className="hl-flag">{right.flag}</div>
          <div className="hl-name">{right.name}</div>
          <div className={'hl-bdg '+(result?'s':'h')}>{result?<><span className="hl-rn">#{right.rank}</span><span className="hl-rl">FIFA Rank</span></>:<span className="hl-q">?</span>}</div>
        </div>
      </div>
      {result&&<div className={'overlay-pop '+(result.ok?'ok':'no')}><div className="overlay-icon">{result.ok?'✓':'✗'}</div><div className="overlay-msg">{result.msg}</div></div>}
      <div className="hl-chain">{history.slice(-5).map((c,i,arr)=>(<div key={i} className="hl-ci"><span>{c.flag}</span><span className="hl-cr">#{c.rank}</span>{i<arr.length-1&&<span style={{color:'#3a5a8e'}}>→</span>}</div>))}</div>
    </>}
  </div>);
}
